import { z } from "zod";

export const categoryAttributeSchema = z.object({
  id: z.string().or(z.number()),
  name: z.string(),
  displayName: z.string().optional(),
  description: z.string().optional(),
  dataType: z.string(),
  isRequired: z.boolean().optional(),
  isSearchable: z.boolean().optional(),
  categoryId: z.string().or(z.number()).optional(),
});

export const categoryAttributeRequestSchema = z.object({
  attributeId: z.number().int(),
  isMandatory: z.boolean(),
  order: z.number().int(),
});

export const categoryAttributeMappingResponseSchema = z.object({
  id: z.number().int(),
  attributeId: z.number().int(),
  attributeName: z.string(),
  isMandatory: z.boolean(),
  order: z.number().int(),
});

export const categoryTabSchema = z.object({
  value: z.string(),
  label: z.string(),
  order: z.number().int().optional(),
  isDefault: z.boolean().optional(),
  viewType: z.string().optional(),
  id: z.string().or(z.number()).optional(),
  categoryId: z.string().or(z.number()).optional(),
});

export const categorySchema = z.object({
  id: z.string().or(z.number()),
  name: z.string(),
  displayName: z.string().nullable().optional(),
  icon: z.string().nullable().optional(),
  isSystem: z.boolean().optional(),
  order: z.number().int().optional(),
  description: z.string().optional(),
  attributesCount: z.number().optional(),
  isLocked: z.boolean().optional(),
  attributes: z.array(categoryAttributeMappingResponseSchema).optional(),
  tabs: z.array(categoryTabSchema).optional(),
});

export const categoryNavigationResponseSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  displayName: z.string().nullable().optional(),
  icon: z.string().nullable().optional(),
  order: z.number().int(),
  tabs: z.array(categoryTabSchema).optional(),
});

export const createCategoryRequestSchema = z.object({
  name: z.string().min(1, "Name is required"),
  displayName: z.string().nullable().optional(),
  icon: z.string().nullable().optional(),
  order: z.number().int().optional(),
  attributes: z.array(categoryAttributeRequestSchema).min(0),
});

export const categoryOrderItemSchema = z.object({
  id: z.number().int().positive(),
  order: z.number().int().min(1),
});

export const reorderCategoriesRequestSchema = z.object({
  categories: z.array(categoryOrderItemSchema).min(1),
});
